import {
  _PreOrderMutationVar,
  toPreOrderProductVar,
} from '@services/requests/orderService/mutations/CreatePreOrderMutation';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';
import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import dayjs from 'dayjs';
import gql from 'graphql-tag';

// Параметры создания индивидуального предложения
export interface CreateIndividualOfferParams {
  bitrixUserIds: number[];
  comment: string;
  products: OrderProduct[];
  currencyId: string | number;
  languageId: string | number;
  validDate: Date;
}

// valid_date есть только у предзаказов ИП, в обычный pre_order_create не передаётся
type IndividualOfferPreOrderVar = _PreOrderMutationVar & { valid_date: string };

// Переменные мутации создания индивидуального предложения
export interface CreateIndividualOfferMutationVars {
  bitrixUserIds: number[];
  comment: string;
  preOrder: IndividualOfferPreOrderVar;
}

/**
 * Итог создания ИП: notFound — бэкенд не нашел ни одного получателя и вернул пустой результат
 */
export type CreateIndividualOfferResult = 'created' | 'notFound' | 'failed';

// Ответ мутации создания индивидуального предложения
export interface CreateIndividualOfferMutationResponse {
  data: { result: string | null } | null;
}

// Мутация создания индивидуального предложения
export class CreateIndividualOfferMutation
  implements GraphQLQuery<CreateIndividualOfferMutationVars>
{
  readonly query: any;

  readonly variables: CreateIndividualOfferMutationVars;

  constructor(params: CreateIndividualOfferParams) {
    this.variables = {
      bitrixUserIds: params.bitrixUserIds,
      comment: params.comment,
      preOrder: {
        currency_id: Number(params.currencyId),
        language_id: Number(params.languageId),
        valid_date: dayjs(params.validDate).endOf('day').toISOString(),
        pre_order_products: params.products.map(toPreOrderProductVar),
      },
    };

    this.query = gql`
      mutation __CREATE_INDIVIDUAL_OFFER__(
        $bitrixUserIds: [Int!]
        $comment: String!
        $preOrder: Pre_Order_Complete_Data!
      ) {
        data: create_individual_offer(
          bitrix_user_id: $bitrixUserIds
          comment: $comment
          pre_order_data: $preOrder
        ) {
          result
        }
      }
    `;
  }
}
